import React from 'react';

export const LandingLoader: React.FC = () => {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0c2a4a] dark:bg-slate-900  overflow-hidden">
            <div className="relative flex flex-col items-center">
                <div className="mt-8 flex flex-col items-center">
                    <img
                        src="/assets/segmentslogo.png"
                        alt="Logo"
                        className="h-16 mb-4 object-contain animate-pulse"
                    />
                    <div className="h-1 w-36 bg-blue-500 rounded-full overflow-hidden">
                        <div className="h-full w-full bg-white/40 animate-loading-bar"></div>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes loading-bar {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
                .animate-loading-bar {
                    animation: loading-bar 1.5s infinite ease-in-out;
                }
            `}</style>
        </div>
    );
};
